import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ToolbarColorButton',
  props: {
    color: {
      type: String,
      required: false,
    },
    isActive: {
      type: Boolean,
      required: false,
    },
  },
  emits: ['input'],
  setup(__props) {

  

  

  const isOpen = ref(false);
  const onBlur = () => {
    isOpen.value = false;
  };
  const onFocus = () => {
    isOpen.value = true;
  };

return { __sfc: true,isOpen, onBlur, onFocus }
}

})